import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class PreProcurementFeatureGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.featureFlagService.isPreProcurementEnabled()) {
      return true;
    }

    this.router.navigate(['/doqfy/dashboard']);
    return false;
  }
}
